var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLuggage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.34375 18.7094V8.47863M16.0625 18.7094V14.7308M8.9375 7.91026V5.63675C8.9375 5.00894 9.46916 4.5 10.125 4.5H14.2812C14.9371 4.5 15.4688 5.00894 15.4688 5.63675V7.91026M16.0625 10.7521H13.0938V13.594V14.7308H18.4375V10.7521H16.0625ZM16.0625 10.7521V7.91026M16.0625 7.91026H5.375C4.06332 7.91026 3 8.92814 3 10.1838V17.0043C3 18.2599 4.06332 19.2778 5.375 19.2778H19.625C20.9367 19.2778 22 18.2599 22 17.0043V10.1838C22 8.92814 20.9367 7.91026 19.625 7.91026H16.0625Z",
    stroke: "#4A5467",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLuggage);
export default __webpack_public_path__ + "static/media/ic-luggage.d13a4e441d8def2fcdb6bb8373fb8fb6.svg";
export { ForwardRef as ReactComponent };